import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import axios from "axios";
import "./hrrpReferenceLIbrary.css";
import "../common/sideTab/sideTab.css";
import Thumbnail from "../common/thumbnail/Thumbnail";
import { fetchResourceMaterialCategoryList } from "../../store/actions/resourceMaterial";
import {
    RESOURCE_MATERIAL_CATEGORY_LIST_API_URL,
    RESOURCE_MATERIAL_LIST_API_URL
} from "../../store/constants/urls";
import { frontendUrl, host } from "../../utils/globals";
import { kbtomb, scrollTop, customCollapse } from "../../utils/helpers";
import { NavLink } from "react-router-dom";
import loading from "../common/loading.gif";
import Nodata from "../common/Nodata";

class HrrpReferenceLibrary extends Component {
    state = {
        referenceTitle: null,
        isLoading: true,
        data: "",
        totalPage: "",
        page: 1,
        categoryParameter: null,
        isFirstCategoryListLoaded: false,
        isMainPageLoaded: false
    };

    async componentDidMount() {

        customCollapse();
        const { isFetched } = this.props.categories;
        !isFetched &&
            this.props.dispatch(
                fetchResourceMaterialCategoryList(
                    RESOURCE_MATERIAL_CATEGORY_LIST_API_URL
                )
            );
        const categoryParameter = this.props.match.params.category;
        if (categoryParameter) {
            let url = `${RESOURCE_MATERIAL_LIST_API_URL}?category_alias=${categoryParameter}&per_page=12`;
            this.setState({ categoryParameter });
            await this.fetchData(url);
            this.paginateData();
        }
        this.setState({ isMainPageLoaded: true });
        scrollTop();
    }

    paginateData() {
        let self = this;
        $(document).on("click", " .pagination > li", e => {
            e.preventDefault();
            this.setState({ isLoading: true });
            let target = $(e.target).closest("li");
            let page = target.data("page");
            let category = target.data("category");
            let url = `${RESOURCE_MATERIAL_LIST_API_URL}?category_alias=${category}&page=${page}&per_page=12`;
            this.setState({ categoryParameter: category });
            page && category && self.fetchData(url);
            self.setState({ page });
            scrollTop();
        });
    }

    async componentDidUpdate(prevProps, prevState) {
        let id = this.props.match.params.category;

        if (prevState.categoryParameter !== this.state.categoryParameter) {
            this.setState({ page: 1 });
        }
        const { resourceMaterialCategory } =
            this.props && this.props.categories;

        let firstCategory =
            resourceMaterialCategory &&
            resourceMaterialCategory[0] &&
            resourceMaterialCategory[0].alias;
        let url = null;

        if (
            window.location.pathname === "/hrrp-reference-library" &&
            !this.state.data &&
            firstCategory &&
            !id
        ) {
            url = `${RESOURCE_MATERIAL_LIST_API_URL}?category_alias=${firstCategory}&per_page=12`;
            await this.fetchData(url);
            this.paginateData();
            this.setState({ isMainPageLoaded: true });
        }
    }

    async fetchData(url) {
        let self = this;
        await axios
            .get(url)
            .then(res => {
                if (res.data) {
                    self.setState({
                        data: res.data.data,
                        totalPage: res.data.totalPage
                    });
                }
            })
            .catch(e => self.setState({ isLoading: false }));

        this.setState({ isLoading: false });
    }

    handleClick = e => {
        let alias = e.target.getAttribute("href");
        alias = alias.replace(/#/g, "");
        let url = `${RESOURCE_MATERIAL_LIST_API_URL}?category_alias=${alias}&per_page=12`;
        let obj = window.location.href;
        window.history.pushState(
            obj,
            "hrrpCategory",
            `/hrrp-reference-library/${alias}`
        );

        this.setState({
            referenceTitle: $(e.target)
                .closest("a")
                .html(),
            isLoading: true,
            categoryParameter: alias,
            isMainPageLoaded: false
        });

        this.fetchData(url);
    };


    render() {
        let { resourceMaterialCategory: category } = this.props.categories;
        let categoryParameter = this.props.match.params.category;
        const firstCategory = category && category[0] && category[0].name;
        let { isEnglish } = this.props;

        let { data, totalPage, isLoading } = this.state;
        let pagination = "";
        if (totalPage > 1) {
            for (let i = 1; i <= totalPage; i++) {
                pagination += `<li class="${
                    this.state.page === i ? "active" : ""
                }" data-page=${i} data-category=${
                    this.state.categoryParameter
                }><a href="#">${i}</a></li>`;
            }
        }

        let referenceTitle = "";

        if (
            !this.state.referenceTitle &&
            categoryParameter &&
            categoryParameter.length > 0
        ) {
            referenceTitle = categoryParameter.split("-").join(" ");
        } else {
            referenceTitle = this.state.referenceTitle;
        }

        return (
            <section id="hrrp-reference-library">
                <div className="hrrp-breadcrumb">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <h1>reference library</h1>
                                <ol className="breadcrumb">
                                    <li>
                                        <NavLink to="/">home</NavLink>
                                    </li>
                                    <li className="active">
                                        reference library
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-sm-3 myScrollspy">
                            <div id="myside" className="xs-collapse-wrapper">
                                <div className="burger hidden-sm hidden-md hidden-lg">
                                    <a href="#" className="pull-right">
                                        <i className="fa fa-bars" />
                                    </a>
                                </div>

                                <div className="xs-collapse">
                                    <div className="inner-title change-title alter-title">
                                        <h1>
                                            resources / materials categories
                                        </h1>
                                    </div>
                                    <aside>
                                        <ul
                                            className="nav nav-tabs"
                                            id="resourceMaterials"
                                        >
                                            {category &&
                                                category.map((d, i) => {
                                                    return d.subCategories &&
                                                        d.subCategories.length >
                                                            0 ? (
                                                        <li
                                                            key={d.name + 1}
                                                            title={d.name}
                                                        >
                                                            <div
                                                                id="accordion"
                                                                className="nav-accordion"
                                                            >
                                                                <a
                                                                    data-toggle="collapse"
                                                                    data-parent="#accordion"
                                                                    href={`#category-${i}`}
                                                                    title={isEnglish ? d.name : d.nepali_name || d.name}
                                                                >
                                                                    {isEnglish ? d.name : d.nepali_name || d.name}
                                                                    {/*<i className="fa fa-plus pull-right"/>*/}
                                                                </a>

                                                                <div
                                                                    id={`category-${i}`}
                                                                    className="panel-collapse collapse"
                                                                >
                                                                    <ul className="nav nav-tabs">
                                                                        {d.subCategories &&
                                                                            d.subCategories.map(
                                                                                data => (
                                                                                    <li
                                                                                        key={data.name + i}
                                                                                    >
                                                                                        <a
                                                                                            href={`#${data.alias}`}
                                                                                            data-toggle="tab"
                                                                                            title={isEnglish ? data.name : data.nameNepali || data.name}
                                                                                            onClick={this.handleClick}
                                                                                        >
                                                                                            {isEnglish ? data.name : data.nameNepali || data.name}
                                                                                        </a>
                                                                                    </li>
                                                                                )
                                                                            )}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ) : (
                                                        <li
                                                            className={
                                                                !categoryParameter &&
                                                                i === 0
                                                                    ? "active"
                                                                    : categoryParameter ===
                                                                      d.alias
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            key={d.name + i}
                                                            title={isEnglish ? d.name : d.nepali_name || d.name}
                                                        >
                                                            <a
                                                                href={`#${d.alias}`}
                                                                data-toggle="tab"
                                                                onClick={this.handleClick}
                                                            >
                                                                {isEnglish ? d.name : d.nepali_name || d.name}
                                                            </a>
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                    </aside>
                                </div>
                            </div>
                        </div>
                        {isLoading ? (
                            <div>
                                <img
                                    src={loading}
                                    alt="loading icon"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%"
                                    }}
                                />
                            </div>
                        ) : (
                            <div className="col-xs-12 col-sm-9">
                                <div className="tab-content">
                                    <div className="tab-pane active" id="gov">
                                        <div className="inner-title change-title">
                                            <h1>
                                                {referenceTitle &&
                                                window.location.pathname !==
                                                    "/hrrp-reference-library"
                                                    ? referenceTitle
                                                    : firstCategory}
                                            </h1>
                                        </div>
                                        <div className="row">
                                            {data && data.length > 0 ? (
                                                data.map(d => (
                                                    <Thumbnail
                                                        thumbTitle={isEnglish ? d.title : d.title_nepali || d.title}
                                                        thumbDate={d.published_date}
                                                        thumbSpace={`${kbtomb(d.file_size)} MB`}
                                                        key={d.id}
                                                        isYoutubeLink={d.has_youtube_link}
                                                        youtubeLink={d.youtube_link}
                                                        thumbImage={d.image_path ? `${host}${d.image_path}` : '/img/logo-new_.svg'}
                                                        thumbDownload={isEnglish ? d.file_path : d.nepali_file_path || d.file_path}
                                                    />
                                                ))
                                            ) : (
                                                <Nodata />
                                            )}


                                        </div>
                                        <ul
                                            className="pagination"
                                            dangerouslySetInnerHTML={{
                                                __html: pagination
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = state => ({
    categories: state.resourceMaterialCategoryList,
    isEnglish: state.changeLanguage.isEnglish
});
export default connect(mapStateToProps)(HrrpReferenceLibrary);
